import { LegalPage } from '../components/Legal/LegalPage';

export const TermsOfServicePage = () => {
  return <LegalPage title="Terms of Service" filename="terms-of-service.md" />;
};